import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFetch(path) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState({ data: null, loading: true, error: null });
    api
      .get(path)
      .then((r) => alive && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => alive && setState({ data: null, loading: false, error: e.response?.status || 500 }));
    return () => {
      alive = false;
    };
  }, [path]);
  return state;
}
